import React from 'react'
import Navbar from '../../Components/Navbar';
// import { Routes, Route } from "react-router-dom"
// import { Link } from 'react-router-dom';
// import { BrowserRouter } from "react-router-dom"
import '../UXcasestudies/Cloudmarketplace.css'
import images from '../../../src/images/User-persona.jpg'
import marketplaceuserpersona from '../../images/marketplaceuserpersona.jpg'
import userjourney from '../../images/user-journey.png'

const Cloudmarketplace = () => {
  return (
    <div>
      <Navbar />

      <div className='MarketplaceContainer'>
        
          <h2 className='MarketplaceHeading'>Cloud Marketplace</h2>

          <div className='MarketplaceContent'>

          <img className='MarketplaceImage1' alt= "" src="https://images.squarespace-cdn.com/content/v1/65d697f92fdee7201e21d3a6/496e6b7d-3dab-49d3-8ada-c03b689f0a1a/Marketplace+mockup+laptop.png?format=2500w" />

          <div className='MarketplaceCaseStudy'>

            <div className='MarketplaceResult'>
          <p>Impact:-</p> <br />
          <p>40% increase in year-over-year revenue </p> <br />
          <p> 50% click rate achieved by implementing a new feature</p>
          </div>

              <h3 className='MarketplaceSubheadings'> Overview</h3>
          
           <p>Bell Canada is a Canadian telecommunications company which provides telephone network to consumers and businesses. 
            The Bell Business Marketplace simplifies buying and managing cloud services for enterprise customers.</p>

           <h4 className='MarketplaceSubheadings2'> My Role and responsibility </h4>

          <p>As a User Experience specialist, my role was to help launch marketplace platform and improve the user experience 
             by collaborating with business stakeholders and vendors.
          </p>



          <div id="PbS"> 
            <h3 className='MarketplaceSubheadings' >Problem Statement </h3>
              <div id='TheWhy'>
                <p> <span className='PbSHeading'> Why this product? </span> <br /> 
                <ul>
                  <li>Customers require a centralized platform to view all their cloud 
                  subscriptions and usage billing. </li>
                  <li>Businesses require cloud experts to (AWS, Azure, GCP & M365)  </li>
                </ul>        
                </p> <br />

                <p> <span className='PbSHeading'>What's wrong with the product?</span> <br />
                
                <ul> The current version
                  <li>led to lengthy meetings with customers about purchase process</li>
                  <li>back-and-forth emails with Customer Success Management team on general admin activities</li>
                  <li>Incohesive flow with the rest of the platform</li>
                </ul>
                    <br />
                </p>
              </div>
            
          </div>



          <div>
          <h3 className='MarketplaceSubheadings' >My Process</h3>
          <p> Every project requires a unique process. For this project I was lucky to be there before its launch</p>
          <p>Below are list of the process i used and followed
            <ul>
              <li> <a href="#understandingmrktplace" src=""> Understanding the cloud and its customers </a> </li>
              <li> <a href="#endtoendmrktplace" src=""> End to end user journey </a> </li>
              <li> <a href="#journeymrktplace" src=""> Marketplace platform journey </a> </li>
              <li> <a href="#prelaunchmrktplace"> Pre-launch User testing and identifying issues </a> </li>
              <li> <a href="#postlaunchmrktplace"> Post-launch Solving issues, Prototype, Design, Usertest, Develop </a>  </li>
              <li> <a href="#extensivemrktplace"> Extensive research plans</a>  </li>
              <li> <a href="#resultsmrktplace">Results and outcomes</a> </li>
              <li> <a href="#lessonsmrktplace"> Lessons learned</a> </li>
              </ul> 
              </p>

          <h4 className='MarketplaceSubheadings2' id="understandingmrktplace">Understanding cloud and its customers </h4>

          <img alt="" src="https://img.freepik.com/free-vector/pink-neon-cloud-icon-digital-networking-system_53876-119486.jpg?t=st=1721239943~exp=1721243543~hmac=93f92465ab88a45fcb04c067b817f300a16925f3e3e695182394359ee1306c37&w=1380" />

          <p>
            <ul>
              <li>I took an AWS cloud practitioner course to understand the cloud and its users </li>
              <li> Bell has existing cloud customers. I spoke with them to gain customer insights</li>
              <li> Insights: Customers goal is to Move applications from on-prem to cloud and reduce cost</li>
            </ul>
            <img alt="" src={images} />
            <img alt="" src={marketplaceuserpersona} />
          </p>

          </div>

          <h4 className='MarketplaceSubheadings2' id="endtoendmrktplace">Overall end-to-end user journey</h4>
          <img alt="" src={userjourney} />
          <p>Created this end to end user journey to understand customer flow and their pain points. 
            This journey map was used to communicate with internal and external stakeholders
          </p>

          <h4 className='MarketplaceSubheadings2'id="journeymrktplace">Marketplace platform user journey</h4>
          <img alt="" src={userjourney} />
          <p>Made this to understand customers&apos; journey inside the marketplace platform and their actions. </p>

          <h4 className='MarketplaceSubheadings2' id="prelaunchmrktplace">Pre-launch user testing and identifying issues</h4>
          <img alt="" src={userjourney} />
          <ol>
            <li>The form to place the order is not clear and customers had to click multiple pages</li>
            <li> Users are not informed about the status of their orders after placing the order</li>
            <li>Users must log in to the marketplace platform to get the username, password and login details 
            to access the subscription</li>
          </ol>

          <h4 className='MarketplaceSubheadings2'>Product launch</h4>
          <p>No blockers. Got approval from stakeholder and team alignment. The Product was launched</p>
          <img alt="" src={userjourney} />


          <h4 className='MarketplaceSubheadings2' id="postlaunchmrktplace">Post-launch process</h4>
          <p>After the launch i started working on solving the issues, creating new features, testing with users and 
            developer handoff
          </p>

          <h4 className='MarketplaceSubheadings2'>Solving issue #1 - Re-designing the form and testing</h4>
          <ul>
            <li>Redesigned the purchase flow</li>
            <li>user test the prototype with customers</li>
            <li>Receive feedback, implement changes</li>
            <li>Submit for developemnt</li>
            <li>Result: New design reduced purchase time by 50%</li>
          </ul>


          <h4 className='MarketplaceSubheadings2'>Solving issue #2 - Solving order status</h4>
          <ul>
            <li>Solution: Send auto responder email to inform customers about the status or delays for over 4 hours.</li>
            <li>Challenge: The vendor said there were no API calls which could give us the status of the order</li>
            <li>Alternate solution and opportunities:
            Include instructions in the email for customers to contact CSM directly or call our 
            customer service team via phone.</li>
          </ul>

          <h4 className='MarketplaceSubheadings2'>Solving issue #3 - Email to have login details</h4>
          <ul>
            <li>Solution: We want the login details to be sent along with the “Subscription provision email” 
              to prevent customers from having to log in again.</li>
            <li>Challenge: The vendor said it was not possible to get the login details in the email  
            </li>
            <li>Alternate solution and opportunities:
            Include information in the subscription email regarding the subsequent steps.</li>
          </ul>


          <h4 className='MarketplaceSubheadings2'>New feature and testing for Admin tasks - 
            Adding/removing users, and Account closures</h4>

            <p>New users were unclear about general tasks ike adding/removing users and account clousre. 
              As a solution, I created a new Frequently Asked Questions (FAQ) web page to address queries.</p>
          <ul>
            <li>Create and collaborated with marketing to get the FAQ's page content </li>
            <li>Designed the FAQ pages by following design system</li>
            <li>User test the prototype with the customers </li>
            <li>Receive feedback from users and implement to design</li>
            <li>Hand off design to the developemnt team</li>
            <li>Result: 50% increase in clicks and reduced multiple emails sent to our customer support team.</li>
          </ul>


          <h4 className='MarketplaceSubheadings2' id="extensivemrktplace">Extensive research plans </h4>
          <img alt="" src={userjourney} />

          <ul>
            <li>Planned and assessed tools such as Zapier, Qualtrics, Surveymonkey, and Delighted for sending 
              CSAT surveys to acquire customer insights for all the portal platforms.</li>
          </ul>



          <h4 className='MarketplaceSubheadings2' id="resultsmrktplace">Results and outcomes</h4>
          <img alt="" src={userjourney} />

          <p>As a result of enhancing the UX/UI and collaboration with stakeholders</p>

          <ul>
            <li>We saw 40% increase in year-over-year revenue</li>
            <li>New purchase flow form design reduced customers purchase time by 50%</li>
            <li>The FAQ feature had 50% increase in clicks and reduced emails sent to our customer support team</li>
            <li>Emails were informative for cusotmers on next steps.</li>
          </ul>

          <p>Other achievements</p>

          <ul>
            
            <li>Evaluated survey tools for customer insights and planned for qualitative and quantitative research data</li>
            <li>Designed an interactive pre-sale checklist for the sales team to improve their process </li>
            <li>Tracked and managed over 50 bugs, created tickets, followed up, 
              and ensured their completion, contributing to 
              the project's success</li>
              <li>Designed and developed emails in HTML/CSS for English and French </li>
              <li>Designed and developed Terms of Conditions web pages for multiple
                  products inside the platform using HTML & CSS for English and French</li>
          </ul>


          <h4 className='MarketplaceSubheadings2' id="lessonsmrktplace">Lessons Learned</h4>
          <img alt="" src={userjourney} />

          <ul>
            <li>Collaboration is key</li>
            <li>Understanding the product, and the business and collaborating with 
              the stakeholders is essential for any project. </li>
            <li>Unforeseen challenges like budget constraints, technology constraints, 
              and lack of resources will happen. Find a common ground between what we want and what can be done.</li>
          </ul>  







          



        </div>
         

        </div>
      </div>



      
      
      
      
      
      








    </div>
  )
}

export default Cloudmarketplace